








import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';

import Plotly from 'src/misc/external/plotly';


@Component
export default class CarbonFootprintPlotWrapperObject extends Vue {
  $refs: {
    plotRef: HTMLElement
  }

  get project() {
    return this.$store.state.currentProject
  }

  get boards() {
    return this.$store.state.currentProject.boards;
  }

  get appMenuMini() {
    return this.$store.state.appMenuMini;
  }

  get card() {
    return this.$store.getters.getCard('GraphsCard');
  }

  get lgAndUp() {
    return this.$vuetify.breakpoint.lgAndUp;
  }

  @Watch('boards', { deep: true })
  onBoardsChanged() {
    Plotly.purge(this.$refs.plotRef);
    this.redrawPlots();
  }

  @Watch('appMenuMini')
  onAppMenuMiniChanged() {
    this.handleResizeDelayed();
  }

  @Watch('card', { deep: true })
  onCardChanged() {
    this.handleResizeDelayed();
  }

  @Watch('lgAndUp')
  onLgAndUpChanged() {
    this.handleResize();
  }

  mounted() {
    this.redrawPlots();
    window.addEventListener('resize', this.handleResize);

    this.handleResizeDelayed();
  }

  redrawPlots() {
    let marginScale = Math.min(1.0, Math.max(0.0, this.$refs.plotRef.getBoundingClientRect().width - 520) / 330);

    var compareTitle = 'kg CO₂/ton';
    var compareValueLabel = 'carbon_footprint';

    var compareSublabel = 'Destination';
    var compareSublabelX = 1.3 - 0.160 * marginScale;
    var compareSublabelY = 1.05;
    var compareSublabelValue = this.project.plant != null ? this.project.plant.name : 'Loading...';

    var compareValueFormats = '.0f';
    var theme: any = this.$vuetify.theme;

    var themeColors = [
      theme.boardColor1,
      theme.boardColor2,
      theme.boardColor3,
      theme.boardColor4,
      theme.boardColor5,
      theme.boardColor6,
      theme.boardColor7,
      theme.boardColor1,
      theme.boardColor2,
      theme.boardColor3,
      theme.boardColor4,
      theme.boardColor5,
      theme.boardColor6,
      theme.boardColor7
    ]

    var data = [];

    var layout = {
      margin: {
        t: 80,
        b: 40,
        l: 110 + 40.0 * marginScale,
        r: 150 + 40.0 * marginScale,
      },
      title: 'Carbon Footprint',
      showlegend: false
    }
    layout['annotations'] = [];
    layout['shapes'] = [];

    for (let j = 0; j < this.boards.length; j++) {
      let board = this.boards[j];

      if (!board.visible ||
          !board.hasBoardResults() ||
          board.hasSimulationErrors() ||
          !board.hasSimulationSuccessWithCarbonFootprint())
        continue;

      var trace = {
        x: [ 1 ],
        y: [ board.simulationResults[0][compareValueLabel] ],
        xaxis: 'x',
        yaxis: 'y',
        marker:{
          color: [ themeColors[j] ],
        },
        hoverinfo:"y",
        type: 'bar',
        name: board.name,
      };

      data.push(trace);
    }

    layout['yaxis'] = {
      hoverformat: compareValueFormats,
      fixedrange: true,
      anchor: 'x',
      title: compareTitle,
      titlefont: { size: 12 },
    };

    layout['xaxis'] = {
      fixedrange: true,
      showticklabels: false,
    };

    layout['annotations'].push({
      xref: 'paper',
      yref: 'paper',
      x: compareSublabelX,
      xanchor: 'center',
      y: compareSublabelY,
      yanchor: 'bottom',
      text: compareSublabel,
      opacity: 0.4,
      font: {
        size: 12,
        color: 'black',
      },
      showarrow: false,
    });

    layout['annotations'].push({
      xref: 'paper',
      yref: 'paper',
      x: compareSublabelX,
      xanchor: 'center',
      y: compareSublabelY - 0.05,
      yanchor: 'bottom',
      text: compareSublabelValue,
      font: {
        size: 12,
      },
      showarrow: false,
    });

    var config = {
      displayModeBar: false
    };

    Plotly.plot( this.$refs.plotRef, data, layout, config);
  }

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResizeDelayed() {
    setTimeout(() => {
      this.handleResize();
    }, 200);
  }

  handleResize() {
    Plotly.purge(this.$refs.plotRef);
    this.redrawPlots();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CarbonFootprintPlotWrapperObject.vue